import React, {useEffect, useState} from 'react';

class IslandModal extends React.Component {

    state = {lang: 'dv'}

    componentDidMount() {
        $('.scrollbar-inner').scrollbar({
            ignoreOverlay: false,
            ignoreMobile: false
        });

        const htmlLang = $('html').attr('lang');
        this.setState({lang: htmlLang});
    }

    render() {
        if (!this.props.island) return null;

        const {
            name,
            formatted_name,
            state,
            population,
            description,
            projects = []
        } = this.props.island;

        return (
            <div className="card shadow position-absolute"
                 style={{ left: '20px', top: '150px', width: '350px', maxHeight: '500px', zIndex: 1001, background: "rgba(255,255,255, 0.8)", }}>
                <span className="circle-icon modal-close-btn"
                      onClick={() => this.props.updateIsland('')}>
                    <i className="fas fa-times"></i>
                </span>
                <div className="card-body">
                    <div className="scrollbar-inner">
                        <h2 className="card-title text-uppercase font-weight-bold h5 mb-3">
                            {formatted_name || name}
                        </h2>

                        <div className="island-details mb-3">
                            {state && (
                                <p className="mb-2">
                                    <strong>{this.state.lang == 'dv' ? "އަތޮޅު" : "Atoll:"}</strong> {state.name}
                                </p>
                            )}

                            {population && (
                                <p className="mb-2">
                                    <strong>{this.state.lang == 'dv' ? "އާބާދީ" : "Population:"}:</strong> {population.toLocaleString()}
                                </p>
                            )}
                        </div>

                        {description && (
                            <div className="mb-3">
                                <h6 className="font-weight-bold">{this.state.lang == 'dv' ? "ތަޢާރަފް" : "Description:"}</h6>
                                <p className="text-black-50 small text-justify">{description}</p>
                            </div>
                        )}

                        {projects && projects.length > 0 && (
                            <div className="ongoing-projects">
                                <h6 className="font-weight-bold">{this.state.lang == 'dv' ? "ކުރިއަށްދާ ޕްރޮޖެކްޓްތައް" : "Ongoing Projects:"}</h6>
                                <ul className="list-unstyled">
                                    {projects.map((project, index) => (
                                        <li key={index} className="mb-2">
                                            <a href={project.permalink} className="text-decoration-none">
                                                {project.title}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default IslandModal;
